import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Chat = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M20.1 20.102a1.2 1.2 0 0 0-1.2 1.2v13.8a1.2 1.2 0 0 0 1.2 1.2h14.758l3.562 4.802c.184.248.577.09.539-.216l-.567-4.586H42a1.2 1.2 0 0 0 1.2-1.2v-13.8a1.2 1.2 0 0 0-1.2-1.2H20.1Z",
    svgColor: "#FFE6D2"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m35.16 35.702 3.064 4.13-.511-4.13H42a.6.6 0 0 0 .6-.6v-13.8a.6.6 0 0 0-.6-.6H20.1a.6.6 0 0 0-.6.6v13.8a.6.6 0 0 0 .6.6h15.06Zm6.84.6a1.2 1.2 0 0 0 1.2-1.2v-13.8a1.2 1.2 0 0 0-1.2-1.2H20.1a1.2 1.2 0 0 0-1.2 1.2v13.8a1.2 1.2 0 0 0 1.2 1.2h14.758l3.562 4.802c.184.248.577.09.539-.216l-.567-4.586H42Z",
    svgColor: "#302C41"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M19.5 29.403h16.8a1.2 1.2 0 0 0 1.2-1.2v-7.5h-18v8.7Z",
    svgColor: "#FFC496"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M33.9 6.602a1.2 1.2 0 0 1 1.2 1.2V25.87a1.2 1.2 0 0 1-1.2 1.2H14.888l-4.44 5.757c-.186.242-.573.082-.534-.221l.711-5.536H6.3a1.2 1.2 0 0 1-1.2-1.2V7.8a1.2 1.2 0 0 1 1.2-1.2h27.6Z",
    svgColor: "#F9923C"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.593 26.47H33.9a.6.6 0 0 0 .6-.6V7.803a.6.6 0 0 0-.6-.6H6.3a.6.6 0 0 0-.6.6V25.87a.6.6 0 0 0 .6.6h5.007l-.657 5.114 3.943-5.114Zm-4.62 5.992h.001Zm4.915-5.391H33.9a1.2 1.2 0 0 0 1.2-1.2V7.8a1.2 1.2 0 0 0-1.2-1.2H6.3a1.2 1.2 0 0 0-1.2 1.2v18.07a1.2 1.2 0 0 0 1.2 1.2h4.325l-.711 5.536c-.04.303.348.464.535.221l4.439-5.757Z",
    svgColor: "#302C41"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M15.9 16.8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0ZM21.9 16.8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0ZM27.9 16.8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0Z",
    svgColor: "#fff"
  }));
});
Chat.displayName = 'Chat';
Chat.defaultProps = {
  'aria-label': 'Chat'
};
export default Chat;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Chat.js
// module id = 3745
// module chunks = 11